// Typed, centralized access to Vite build-time environment variables.
// All values fall back to sensible local-dev defaults so the app boots without
// a configured .env (Sprint 00 foundation).

const source = import.meta.env as Record<string, string | undefined>;
const productionOrigin =
  import.meta.env.PROD && typeof window !== 'undefined' ? window.location.origin : '';

const read = (key: string): string | undefined => source[key];

export interface AppEnv {
  apiBaseUrl: string;
  wsUrl: string;
  mapboxToken?: string;
  googleMapsBrowserKey?: string;
  googleMapsMapId?: string;
  appName: string;
  environment: string;
  isDev: boolean;
  digitalTwinEngine: 'legacy' | 'unreal' | 'auto';
  unrealPixelStreamingEnabled: boolean;
  unrealTwinFallbackEnabled: boolean;
}

function readEngineMode(value: string | undefined): 'legacy' | 'unreal' | 'auto' {
  if (value === 'unreal' || value === 'auto' || value === 'legacy') return value;
  return 'legacy';
}

export const env: AppEnv = {
  apiBaseUrl:
    read('VITE_API_BASE_URL') ??
    (import.meta.env.PROD ? '/api/v1' : 'http://localhost:4000/api/v1'),
  wsUrl: read('VITE_WS_URL') ?? (productionOrigin || 'http://localhost:4000'),
  mapboxToken: read('VITE_MAPBOX_TOKEN'),
  googleMapsBrowserKey: read('VITE_GOOGLE_MAPS_BROWSER_KEY'),
  googleMapsMapId: read('VITE_GOOGLE_MAPS_MAP_ID'),
  appName: read('VITE_APP_NAME') ?? 'HELIOS ConstructionOS',
  environment: read('VITE_APP_ENV') ?? import.meta.env.MODE ?? 'development',
  isDev: import.meta.env.DEV,
  digitalTwinEngine: readEngineMode(read('VITE_DIGITAL_TWIN_ENGINE')),
  unrealPixelStreamingEnabled: read('VITE_UNREAL_PIXEL_STREAMING_ENABLED') === 'true',
  unrealTwinFallbackEnabled: (read('VITE_UNREAL_TWIN_FALLBACK_ENABLED') ?? 'true') === 'true',
};
